<template>
  <layout-main-inner title="省市区">
    <layout-card-wrap v-loading="loading">

      <el-cascader-panel ref="panel" v-model="value" class="custom-cascader-panel1"
                         :options="cityTree"
                         :props="props">
        <template slot-scope="{ data }">
          <i style="margin-right: 12px" v-if="data.level ===2" class="el-icon-plus" @click="addArea(data, $event)"></i>
          <i style="margin-right: 12px" v-if="data.level ===3" class="el-icon-edit" @click="editArea(data, $event)"></i>
          <span>{{ data.areaName }}</span>
        </template>
      </el-cascader-panel>
    </layout-card-wrap>
    <area-edit-modal ref="modal"
                       :callback="getareatree" />
                        <area-add-modal ref="add"
                       :callback="getareatree" />
  </layout-main-inner>
</template>

<script>
import AreaEditModal from './busi/area-edit-modal.vue'

import { mapState } from 'vuex'
import AreaAddModal from './busi/area-add-modal.vue'
export default {
  name: 'hscode-list',
  components: { AreaEditModal, AreaAddModal },
  data () {
    return {
      loading: false,
      cityTree: [],
      value: null,
      props: {
        value: 'areaCode',
        children: 'children',
        label: 'areaName'
      }
    }
  },
  computed: {
    ...mapState({
      userPermission: state => state.account.permission
    })
  },
  methods: {
    addArea (data, $event) {
      $event.preventDefault()
      $event.stopPropagation()
      this.$refs.add.init({
        provinceName: data.provinceName,
        provinceCode: data.provinceCode,
        cityName: data.cityName,
        cityCode: data.cityCode,
        areaCode: '',
        areaName: ''
      })
    },
    editArea (data, $event) {
      console.log(data)
      $event.preventDefault()
      $event.stopPropagation()
      this.$refs.modal.init(data)
    },
    getareatree (v) {
      if (v) {
        this.value = v
      }
      this.loading = true
      this.$store.dispatch('delivery/getareatree', {
        payload: {},
        success: (res) => {
          res.data.areaNodes.forEach(i => {
            i.provinceCode = i.areaCode
            i.provinceName = i.areaName
            i.children.forEach(s => {
              s.provinceCode = i.areaCode
              s.provinceName = i.areaName
              s.cityCode = s.areaCode
              s.cityName = s.areaName
              s.children = s.children || []
              s.children.forEach(m => {
                m.provinceCode = i.areaCode
                m.provinceName = i.areaName
                m.cityCode = s.areaCode
                m.cityName = s.areaName
                m.districtCode = m.areaCode
                m.districtName = m.areaName
              })
            })
          })
          this.cityTree = res.data.areaNodes
          this.loading = false
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  },
  mounted () {
    this.getareatree()
    console.log(this.$refs.panel)
  }
}
</script>
<style lang="stylus">
.custom-cascader-panel1 {
  .el-cascader-menu__wrap {
    height: auto !important;
  }
  .el-cascader-node.is-active{
    .el-icon-check {
      display none
    }
  }
}
</style>
